<template>
  <navbar
    position="aboslute"
    type="white"
    :transparent="false"
    menu-classes="ml-auto"
  >
    <template>
      <router-link v-popover:popover1 class="navbar-brand text-primary" to="/">
        <img
          v-if="config && config.isGeodidalab"
          src="@/assets/images/logo.webp"
          class="img-logo"
        />
        <img
          v-else
          src="@/assets/images/istitutomosso/Logo_Homepage.png"
          class="img-logo-mosso"
        />
        <!-- <h3 v-if="config && !config.isGeodidalab" class="m-0 text-black">
          <b>I</b>STITUTO <b>A</b>NGELO <b>M</b>OSSO
        </h3> -->
      </router-link>

      <!--
      <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="200"
        trigger="hover"
      >
        <div class="popover-body">
          Designed by Invision. Coded by Creative Tim
        </div>
      </el-popover>
      -->
    </template>

    <template slot="navbar-menu">
      <li class="nav-item" @click="closeMobileMenu()">
        <router-link class="nav-link black-text" to="/elencotimeline">
          <i class="fa fa-clock-o fa-lg px-1"></i> La storia
        </router-link>
      </li>

      <li class="nav-item" @click="closeMobileMenu()">
        <router-link class="nav-link black-text" to="/strumenti">
          <i class="fa fa-beer fa-lg px-1"></i> Strumenti
        </router-link>
      </li>

      <li class="nav-item" @click="closeMobileMenu()">
        <router-link class="nav-link black-text" to="/esperimenti">
          <i class="fa fa-thermometer-three-quarters fa-lg px-1"></i> Attività
        </router-link>
      </li>

      <li
        class="nav-item"
        @click="closeMobileMenu()"
        
      >
        <!-- v-if="config && config.isGeodidalab"-->
        <router-link
          class="nav-link black-text"
          :to="config && config.isGeodidalab ? '/percorsi' : '/elencopercorsi'"
        >
          <i class="fa fa-map-o fa-lg px-1"></i> Itinerari
        </router-link>
      </li>

      <li class="nav-item" @click="closeMobileMenu()">
        <router-link class="nav-link black-text" to="/doveSiamo">
          <i class="fa fa-map-pin fa-lg px-1"></i> Dove Siamo
        </router-link>
      </li>

      <li class="nav-item" @click="closeMobileMenu()">
        <router-link class="nav-link black-text" to="/contatti">
          <i class="now-ui-icons users_single-02"></i> Contatti
        </router-link>
      </li>


      <li class="nav-item" v-if="config && config.isGeodidalab">
        <a
          class="nav-link black-text"
          href="https://forms.gle/7Uzw2xp4KAKg9Fey5"
          target="_blank"
        >
          <i class="now-ui-icons ui-2_like"></i>
          <p>VALUTAZIONE</p>
        </a>
      </li>
      <!--
      <drop-down
        tag="li"
        title="Components"
        icon="now-ui-icons design_app"
        class="nav-item"
      >
        <nav-link to="/">
          <i class="now-ui-icons business_chart-pie-36"></i> All components
        </nav-link>
        <a
          href="https://demos.creative-tim.com/vue-now-ui-kit/documentation"
          target="_blank"
          class="dropdown-item"
        >
          <i class="now-ui-icons design_bullet-list-67"></i> Documentation
        </a>
      </drop-down>
      <drop-down
              tag="li"
              title="Examples"
              icon="now-ui-icons design_image"
              class="nav-item"
      >
        <nav-link to="/landing">
          <i class="now-ui-icons education_paper"></i> Landing
        </nav-link>
        <nav-link to="/login">
          <i class="now-ui-icons users_circle-08"></i> Login
        </nav-link>
        <nav-link to="/profile">
          <i class="now-ui-icons users_single-02"></i> Profile
        </nav-link>
      </drop-down>

      <li class="nav-item">
        <a
          class="nav-link btn btn-neutral"
          href="https://www.creative-tim.com/product/vue-now-ui-kit-pro"
          target="_blank"
        >
          <i class="now-ui-icons arrows-1_share-66"></i>
          <p>Upgrade to PRO</p>
        </a>
      </li>
      -->

      <!--
      <li class="nav-item">
        <a
            class="nav-link"
            rel="tooltip"
            title="Follow us on Twitter"
            data-placement="bottom"
            href="https://twitter.com/CreativeTim"
            target="_blank"
        >
          <i class="fab fa-twitter"></i>
          <p class="d-lg-none d-xl-none">Twitter</p>
        </a>
      </li>
      <li class="nav-item">
        <a
            class="nav-link"
            rel="tooltip"
            title="Like us on Facebook"
            data-placement="bottom"
            href="https://www.facebook.com/CreativeTim"
            target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a
            class="nav-link"
            rel="tooltip"
            title="Follow us on Instagram"
            data-placement="bottom"
            href="https://www.instagram.com/CreativeTimOfficial"
            target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      -->
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from "@/components";
import { data } from "dom7";
import { Popover } from "element-ui";
import { config } from "../utils/config";
import $ from "jquery";

export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    //DropDown,
    Navbar,
    [Popover.name]: Popover,
  },
  data() {
    return {
      config: null,
      windowWidth: 0,
    };
  },
  mounted() {
    this.config = config;
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });
  },

  methods: {
    closeMobileMenu() {
      if (!this.isLarge) {
        document.getElementById("close-menu-mobile").click();
      }
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 992;
    },
  },
};
</script>

<style scoped>
.img-logo {
  width: 60%;
}

.img-logo-mosso {
  width: 130px;
}

.black-text {
  color: #000000 !important;
}
</style>
